/******/ (() => { // webpackBootstrap
/*!**************************************************!*\
  !*** ./src/scripts/collections/price-filters.js ***!
  \**************************************************/
(function () {
  function initPriceFilters() {
    var priceCheckboxes = document.querySelectorAll('.custom-price-checkbox');
    var hiddenMin = document.getElementById('hidden-price-min');
    var hiddenMax = document.getElementById('hidden-price-max');
    var form = document.querySelector('[data-faceted-filter-form]') || document.querySelector('.faceted-filter-form');
    if (!priceCheckboxes.length || !hiddenMin || !hiddenMax || !form) return;
    priceCheckboxes.forEach(function (checkbox) {
      if (checkbox.dataset.priceBound) return;
      checkbox.dataset.priceBound = 'true';
      checkbox.addEventListener('change', function () {
        if (this.checked) {
          priceCheckboxes.forEach(function (cb) {
            if (cb !== checkbox) cb.checked = false;
          });
          hiddenMin.value = this.getAttribute('data-min');
          hiddenMax.value = this.getAttribute('data-max');
        } else {
          hiddenMin.value = '';
          hiddenMax.value = '';
        }

        // Dispatch events so the theme's JS catches the update
        hiddenMin.dispatchEvent(new Event('input', {
          bubbles: true
        }));
        hiddenMin.dispatchEvent(new Event('change', {
          bubbles: true
        }));
        form.dispatchEvent(new Event('input', {
          bubbles: true
        }));
        form.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initPriceFilters);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initPriceFilters();
  }
})();
/******/ })()
;